module.exports = __webpack_public_path__ + "static/media/wood.ede1ed92.jpg";